import {
    getList as _getList,
    getAll as _getAll,
    add as _add,
    update as _update,
    deleteAll as _deleteAll,
} from "../../api";

const BASE_URL = "/settings/modules";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "id",
    orderDirection: "desc",
    pageNumber: 0,
    pageSize: 5,
};

export function getAll({ onSuccess, onError }) {
    _getAll({ url: BASE_URL, onSuccess, onError });
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}
